// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_square_ribbed_shell/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_square_ribbed_shell: ModuleSchema = {
  "id": "core_square_ribbed_shell",
  "uniqueId": "B3D_RIB02",
  "createdAt": "2026-10-10T15:36:50.770Z",
  "updatedAt": "2026-10-10T15:43:25.346Z",
  "label": "Square Ribbed Shell",
  "description": "Khối trụ mẫu với các gân vuông/chữ nhật lồi chạy dọc quanh vỏ.",
  "category": "core_geometry",
  "tags": [
    "core",
    "geometry",
    "shell",
    "rib",
    "raised"
  ],
  "sliders": [
    {
      "key": "radius",
      "label": "Shell Radius",
      "min": 8,
      "max": 80,
      "step": 1,
      "default": 28,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Shell Height",
      "min": 8,
      "max": 80,
      "step": 1,
      "default": 24,
      "unit": "mm"
    },
    {
      "key": "ribCount",
      "label": "Number of Convex Ribs",
      "min": 0,
      "max": 48,
      "step": 1,
      "default": 24
    },
    {
      "key": "ribEndMargin",
      "label": "Rib End Margin",
      "min": 0,
      "max": 12,
      "step": 0.5,
      "default": 1.5,
      "unit": "mm"
    },
    {
      "key": "ribWidth",
      "label": "Raised Rib Width",
      "min": 0.4,
      "max": 8,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm"
    },
    {
      "key": "ribHeight",
      "label": "Raised Rib Height",
      "min": 0.1,
      "max": 8,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "shell",
      "label": "Square Ribbed Shell",
      "default": "#ffffff",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "name": "Square Ribbed Shell",
      "parts": [
        {
          "name": "Square Ribbed Shell",
          "groupId": 0
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "name": "Square Ribbed Shell",
      "groupId": 0
    }
  ]
};
